export default (parentElement, options) => {
    const element = document.createElement('script');
    element.src = options.src;
    if (options.id) {
        element.id = options.id;
    }
    parentElement.appendChild(element);
    return element;
};